module.exports = __webpack_public_path__ + "static/img/PC-8.8f6ed10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcyixuekao/PC-8.png
// module id = GVtB
// module chunks = 0